/**
 * Sección Actividad de Agentes — quién ha trabajado, ranking, evolución.
 */
import { h, apiClient } from './_common.js';

export async function renderActividadAgentes(root) {
  root.innerHTML = '';
  const wrap = h('div', { class: 'animate-fade-in max-w-6xl mx-auto' }, [
    h('div', { class: 'flex items-center justify-between mb-6 flex-wrap gap-3' }, [
      h('div', {}, [
        h('h2', { class: 'font-display text-3xl font-bold' }, '📊 Actividad de Agentes'),
        h('p', { class: 'text-ink-300' }, 'Quién ha trabajado de verdad · ranking · evolución diaria'),
      ]),
      h('div', { class: 'flex gap-2 items-center' }, [
        h('label', { class: 'text-sm text-ink-400' }, 'Ventana:'),
        h('select', { id: 'act-window', class: 'bg-base-800 border border-base-600 rounded px-2 py-1 text-sm' }, [
          h('option', { value: '1' }, '24h'),
          h('option', { value: '7', selected: 'selected' }, '7 días'),
          h('option', { value: '30' }, '30 días'),
          h('option', { value: '90' }, '90 días'),
        ]),
        h('button', { class: 'text-xs text-gold-400 px-2 py-1 border border-base-700 rounded', onclick: () => renderActividadAgentes(root) }, '⟳'),
      ]),
    ]),
    h('div', { id: 'act-kpis', class: 'grid grid-cols-2 md:grid-cols-5 gap-3 mb-6' }),
    h('div', { class: 'grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6' }, [
      h('div', { id: 'act-ranking' }),
      h('div', { id: 'act-evolution' }),
    ]),
    h('div', { id: 'act-recent' }),
  ]);
  root.appendChild(wrap);

  const sel = wrap.querySelector('#act-window');
  sel.addEventListener('change', () => load(sel.value));
  await load('7');

  async function load(days) {
    wrap.querySelector('#act-kpis').innerHTML = '<div class="text-ink-400 text-sm col-span-5">Cargando...</div>';
    try {
      const r = await apiClient.get(`/api/v1/agents/activity?days=${days}`);
      renderData(wrap, r);
    } catch (e) {
      wrap.querySelector('#act-kpis').innerHTML = '';
      wrap.querySelector('#act-kpis').appendChild(h('div', { class: 'text-rose-400 text-sm col-span-5' }, 'Error: ' + (e?.message || e)));
    }
  }
}

function renderData(wrap, r) {
  const t = r.totals || {};
  const kpis = wrap.querySelector('#act-kpis');
  kpis.innerHTML = '';
  const cards = [
    ['Acciones totales', t.all ?? 0, 'gold'],
    ['Consultas especialistas', t.specialistConsults ?? 0, 'emerald'],
    ['Decisiones brain', t.brainActions ?? 0, 'sky'],
    ['Ejecutadas', t.executed ?? 0, 'emerald'],
    ['Pendientes / Fallos', `${t.pending ?? 0} / ${t.failed ?? 0}`, 'amber'],
  ];
  cards.forEach(([k, v, c]) => kpis.appendChild(
    h('div', { class: 'rounded-lg border border-base-700 bg-base-900/60 p-4' }, [
      h('div', { class: 'text-xs uppercase tracking-wider text-ink-400 mb-1' }, k),
      h('div', { class: `text-2xl font-bold text-${c}-400` }, String(v)),
    ])
  ));

  // Ranking
  const rb = wrap.querySelector('#act-ranking');
  rb.innerHTML = '';
  rb.appendChild(h('h3', { class: 'font-semibold mb-3' }, '🏆 Top agentes que más trabajan'));
  if (!r.ranking?.length) {
    rb.appendChild(h('div', { class: 'text-ink-400 text-sm' }, 'Aún no hay ranking. El próximo cron de las :00 o :30 invocará especialistas.'));
  } else {
    const list = h('div', { class: 'space-y-2' });
    r.ranking.forEach((a, i) => {
      list.appendChild(h('div', { class: 'flex items-center gap-3 rounded border border-base-700 bg-base-900/40 p-3' }, [
        h('div', { class: 'text-xl font-bold text-gold-400 w-8' }, '#' + (i + 1)),
        h('div', { class: 'flex-1' }, [
          h('div', { class: 'text-sm font-semibold' }, a.agentName),
          h('div', { class: 'text-xs text-ink-400' }, `${a.vpName} · último: ${a.lastRun ? new Date(a.lastRun).toLocaleString('es-ES') : '—'}`),
        ]),
        h('div', { class: 'text-right' }, [
          h('div', { class: 'text-lg font-bold text-emerald-400' }, String(a.runs)),
          h('div', { class: 'text-xs text-ink-400' }, 'runs'),
        ]),
      ]));
    });
    rb.appendChild(list);
  }

  // Evolution
  const ev = wrap.querySelector('#act-evolution');
  ev.innerHTML = '';
  ev.appendChild(h('h3', { class: 'font-semibold mb-3' }, '📈 Actividad por día'));
  const days = Object.keys(r.byDay || {}).sort();
  if (!days.length) {
    ev.appendChild(h('div', { class: 'text-ink-400 text-sm' }, 'Aún sin datos diarios.'));
  } else {
    const max = Math.max(...Object.values(r.byDay));
    const bars = h('div', { class: 'space-y-1' });
    days.forEach((d) => {
      const v = r.byDay[d];
      const pct = (v / max) * 100;
      bars.appendChild(h('div', { class: 'flex items-center gap-2' }, [
        h('div', { class: 'w-20 text-xs text-ink-400 font-mono' }, d),
        h('div', { class: 'flex-1 bg-base-800 rounded h-6 relative overflow-hidden' }, [
          h('div', { class: 'bg-gradient-to-r from-gold-600 to-gold-400 h-full', style: `width: ${pct}%` }),
        ]),
        h('div', { class: 'w-10 text-right text-sm font-bold' }, String(v)),
      ]));
    });
    ev.appendChild(bars);
  }

  // Recent consults
  const rc = wrap.querySelector('#act-recent');
  rc.innerHTML = '';
  rc.appendChild(h('h3', { class: 'font-semibold mb-3' }, '💬 Últimas opiniones de especialistas'));
  if (!r.recentConsults?.length) {
    rc.appendChild(h('div', { class: 'text-ink-400 text-sm' }, 'Sin opiniones aún. Cada ciclo del orquestador (cada 30 min) invoca a 3 VPs.'));
  } else {
    const list = h('div', { class: 'space-y-2' });
    r.recentConsults.forEach((c) => {
      list.appendChild(h('div', { class: 'rounded border-l-4 border-gold-500/40 bg-base-900/40 pl-3 pr-3 py-2' }, [
        h('div', { class: 'flex items-center justify-between text-xs text-ink-400 mb-1' }, [
          h('span', {}, c.vp + ' · ' + c.agent),
          h('span', {}, new Date(c.ts).toLocaleString('es-ES')),
        ]),
        h('div', { class: 'text-sm text-ink-200' }, c.opinion),
      ]));
    });
    rc.appendChild(list);
  }
}
